
import { defineComponent } from "vue";
import { getNoticeMyShop, delNotice } from "@/api/noticeApi";
import { getNoticeOrderNoById } from "@/api/shopApi";
import runEvn from "@/modular/runEvn/RunEvn";
const fileBaseUrl = runEvn().fileBaseUrl;
import { useRouter } from "vue-router";

export default defineComponent({
    name: "ShopNoticeHome",
    setup() {
        return {
            router: useRouter(),
        };
    },
    activated() {
        if (window.history.state.forward == null) {
            if (this.$refs.appList) {
                this.$refs.appList.refresh();
            }
        }
    },
    methods: {
        async loadData({ index, setData }) {
            const datainfo = await getNoticeMyShop(index, this.pageSize);
            this.totacount = datainfo.total;
            const arr = datainfo.rows;
            // 设置已读时间游标
            let noticeTime = 0;
            if (localStorage["noticeTimeShop"]) {
                noticeTime = localStorage["noticeTimeShop"];
            }
            localStorage["noticeTimeShop"] = new Date().getTime();
            for (let index = 0; index < arr.length; index++) {
                const element = arr[index];
                if (element.times < noticeTime) {
                    element.isRead = true;
                }
            }
            setData(arr, this.totacount);
        },
        firstImg(imgs) {
            const img = imgs.split(",")[0];
            return this.img(img);
        },
        img(key: string) {
            return fileBaseUrl + key;
        },
        async go(data) {
            data.isRead = true;
            const orderId = data.linkId;
            const orderInfo = await getNoticeOrderNoById(orderId);
            const orderNo = orderInfo.orderNo;
            this.router.push(`/shop/my/order/details/${orderNo}`);
        },
        async delNotice(id) {
            const isOk = await delNotice(id);
            if (isOk) {
                this.$toast("删除成功");
                this.$refs.appList.refresh();
            }
        },
    },
    data() {
        return {
            pageSize: 20,
        };
    },
});
